import { RGBELoader } from 'three/addons/loaders/RGBELoader.js'
import { useEffect, useMemo, useState } from 'react'
import { useLoader } from '@react-three/fiber'
import { Environment, useTexture } from '@react-three/drei'
import { useSpring, animated } from '@react-spring/three'

export default function EnvironmentTransitioner({ pages, pageIndex }) {
  const envMapURLs = useMemo(() => pages.map((page) => `environment-map/${page.envMapFilename}.hdr`))
  let activeEnvMap = envMapURLs[pageIndex]

  // const textures = useLoader(RGBELoader, envMapURLs)

  // const springProps = useSpring({
  //   texture: textures[pageIndex],
  //   config: { duration: 1000 },
  // })

  // let activeEnvMap = envMapURLs[pageIndex]
  const [rotationY, setRotationY] = useState(Math.PI * 0.75)

  useEffect(() => {
    activeEnvMap = envMapURLs[pageIndex]

    switch (pageIndex) {
      case 0:
        setRotationY(Math.PI * 0.75)
        break
      case 1:
        setRotationY(Math.PI * 1)
        break
      case 2:
        setRotationY(Math.PI * 1)
        break
      case 3:
        setRotationY(Math.PI * 1)
        break
      case 4:
        setRotationY(Math.PI * 0.5)
        break
      case 5:
        setRotationY(Math.PI * 0.5)
        break
      case 6:
        setRotationY(Math.PI * 1.25)
        break
    }
  }, [pageIndex])

  return <Environment background={true} files={activeEnvMap} path="/" backgroundRotation={[0, rotationY, 0]} />
  // return (
  //   <animated.group>
  //     <Environment files={springProps.texture.toString()} background={true} backgroundRotation={[0, rotationY, 0]} />
  //   </animated.group>
  // )
}
